/** Identifiant du build courant (injecté au compile via Vite). */
export const APP_BUILD: string =
  typeof __APP_BUILD__ !== 'undefined' && __APP_BUILD__ ? __APP_BUILD__ : 'dev';
